export enum PerdoruesiStatusi {
  Online = 0,
  Away = 1
}